// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"ClosePlayerButton_closeIcon__1Cko_"};